// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1L_rU","title":"FrontImage_title__guzx2"};